import widgetFieldTypes from '@/components/BlockEditorWidget/widgetFieldTypes.js';
import { SHOW_ACTION_SECTION_MINI_APPS, SHOW_WIDGET_LAYOUT_MINI_APPS } from './widget-service.const';
import { FieldType } from '@/components/BlockEditorWidget/widgetFieldTypes.const';

// Private
const getDefaultIdentifierForWidgetField = (widgetFieldType, widgetField) => `${widgetFieldType.name} #${widgetField.order + 1}`;

const shouldShowWidgetLayoutSettings = ({ miniAppType, isMiniApp }) => SHOW_WIDGET_LAYOUT_MINI_APPS.includes(miniAppType) || !isMiniApp;
const isImageEditorMiniApp = (fieldType) => fieldType === FieldType.ImageEditor;

const shouldShowActionSection = (miniAppType) => SHOW_ACTION_SECTION_MINI_APPS.includes(miniAppType);

const isAiMiniAppWidget = (widgetFields) => widgetFields?.length === 1 && widgetFields[0].field_type === FieldType.AIInput;

const getDoneBtnLabel = ({ widgetFields, submitText }) =>
	isAiMiniAppWidget(widgetFields) ? 'Use last answer' : (submitText || {}).value || 'Done';

const getIdentifierForWidgetField = (widgetField, getDefaultIdentifierExtraParams) => {
	const widgetFieldType = widgetFieldTypes[widgetField.field_type];
	if (widgetFieldType.getDefaultIdentifierForWidgetField) {
		return widgetFieldType.getDefaultIdentifierForWidgetField(widgetField, getDefaultIdentifierExtraParams);
	}
	return (
		widgetField.metadata.options?.identifier?.value ||
		widgetField.metadata.options?.title?.value ||
		getDefaultIdentifierForWidgetField(widgetFieldType, widgetField)
	);
};

// Public
const replaceKeyWithIdentifier = (widget, key, getDefaultIdentifierExtraParams) => {
	const widgetFields = widget.fields;
	const trimmedKey = key.replace('values.', '');
	const pathVars = trimmedKey.split('.');
	const widgetFieldId = pathVars.shift().split('[')[0];
	const widgetField = widgetFields.find((wf) => wf.id === widgetFieldId);
	if (!widgetField) {
		return null;
	}

	const widgetFieldName = getIdentifierForWidgetField(widgetField, getDefaultIdentifierExtraParams);
	const hasPath = pathVars.length > 0;
	let title = widgetFieldName;
	if (hasPath) {
		if (title) {
			title += '.';
		}
		title += pathVars.join('.');
	}
	return title;
};

const saveMappingsInMapperWidgetField = async (
	value,
	currentInterface,
	workflowVersionId,
	widgetFieldUUID,
	saveWidgetFunc,
	remove = false
) => {
	const widgetFields = currentInterface?.fields;
	const updatedField = widgetFields.find((x) => x.id === widgetFieldUUID);
	if (updatedField) {
		if (remove) {
			if (updatedField.metadata.source.mappings) {
				updatedField.metadata.source.mappings = updatedField.metadata.source.mappings.filter((x) => x.originalKey !== value.originalKey);
			}
		} else {
			if (updatedField.metadata.source.mappings) {
				const mapping = updatedField.metadata.source.mappings.find((x) => x.originalKey == value.originalKey);
				if (!mapping) {
					updatedField.metadata.source.mappings.push(value);
				} else {
					mapping.displayName = value.displayName;
				}
			} else {
				updatedField.metadata.source.mappings = [value];
			}
		}

		await saveWidgetFunc({ data: { ...currentInterface, workflowVersionId } });
	} else {
		console.log('updatedField not found');
	}
};

const saveParamsMapInMapperWidgetField = async (source, currentInterface, workflowVersionId, widgetFieldUUID, saveWidgetFunc) => {
	const widgetFields = currentInterface?.fields;
	const updatedField = widgetFields.find((x) => x.id === widgetFieldUUID);
	if (updatedField) {
		updatedField.metadata.source = { ...(updatedField.metadata.source || {}), ...source };
		await saveWidgetFunc({ data: { ...currentInterface, workflowVersionId } });
	} else {
		console.log('updatedField not found for params map');
	}
};

const saveFieldInMapperWidgetField = async (
	fieldName,
	fieldValue,
	currentInterface,
	workflowVersionId,
	widgetFieldUUID,
	saveWidgetFunc
) => {
	const widgetFields = currentInterface?.fields;
	const updatedField = widgetFields.find((x) => x.id === widgetFieldUUID);
	if (updatedField) {
		updatedField.metadata.source[fieldName] =
			typeof fieldValue === 'object' ? { ...(updatedField.metadata.source[fieldName] || {}), ...fieldValue } : fieldValue;
		await saveWidgetFunc({ data: { ...currentInterface, workflowVersionId } });
	} else {
		console.log('updatedField not found for params map');
	}
};

const WidgetService = {
	replaceKeyWithIdentifier,
	saveMappingsInMapperWidgetField,
	saveFieldInMapperWidgetField,
	saveParamsMapInMapperWidgetField,
	shouldShowActionSection,
	shouldShowWidgetLayoutSettings,
	isImageEditorMiniApp,
	isAiMiniAppWidget,
	getDoneBtnLabel,
};

export default WidgetService;
